export class CustomerSatisfactionUpdate {
    id!: number;
    companyId!: number;
    customerId!: string;
    customerSatisfactionRating!: number;
}
